import { useEffect, useState } from 'react';
import { getPatientById } from 'api/account/getPatient';
import { Button } from 'components/core/button';
import { FooterChildrenWrapper } from 'components/structure/footer/FooterChildrenWrapper';
import { FooterPortal } from 'components/structure/footer/FooterPortal';
import { useQueryParams } from 'hooks/useQueryParams';
import { useTrackPageVisit } from 'hooks/useTrackPageVisit';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { NpExclusions } from '../account/NpExclusions';
import OnboardingTitle from '../components/OnboardingTitle';
import { CommonOnboardingPage, MemberProgram } from '../constants';

const ExclusionNpComponent = () => {
  const push = useNavigate();
  const t = useTranslations('RelationshipPage');

  const { getParam } = useQueryParams();
  const memberId = getParam('memberId');
  const [memberName, setMemberName] = useState('');

  useTrackPageVisit(CommonOnboardingPage.Exclusions, MemberProgram.NP, memberId);

  useEffect(() => {
    getPatientById(memberId)
      .then((response) => {
        if (response) {
          setMemberName(response.firstName);
        }
      })
      .catch((error) => {
        console.error('Error fetching patient data:', error);
      });
  }, [memberId]);

  const handleContinue = async (button: string) => {
    if (button === 'no') {
      push(`/np/members/${memberId}/eligibility`);
    } else if (button === 'yes') {
      push(`/np/members/${memberId}/exclusion-confirm`);
    }
  };

  return (
    <>
      <OnboardingTitle title={`Do any of the following apply to ${memberName}?`} />
      <div>
        <NpExclusions />
      </div>
      <FooterPortal>
        <FooterChildrenWrapper>
          <Button onClick={() => handleContinue('yes')} variant="secondary" data-testid="yes">
            <span className="font-semibold">{t('yes')}</span>
          </Button>
          <Button onClick={() => handleContinue('no')} data-testid="no">
            <span className="font-semibold">{t('no')}</span>
          </Button>
        </FooterChildrenWrapper>
      </FooterPortal>
    </>
  );
};

export default ExclusionNpComponent;
